import { Box, Typography } from "@mui/material";
import React from "react";

const NotFound = () => {


  return (
    <Box sx={{ textAlign: "center", mt: 10 }}>
      <Typography variant="h4">Not Found</Typography>
    </Box>
  );
};

export default NotFound;
